import React from 'react';

import SearchMap from './SearchMap';
import SearchMapDesktop from './SearchMapDesktop';
import SearchMapMobileWrapped from './SearchMapMobile';

const SearchMapSplitter = (props) => {
    const {
        ...mapProps
    } = props;

    let nonInteractiveMobileSpacing = 'eds-l-pad-bot-6';

    let MapToShow = SearchMap;

    if (props.featureFlags.searchMapEnhancements) {
        nonInteractiveMobileSpacing = '';

        if (props.isMobile) {
            MapToShow = SearchMapMobileWrapped;
        } else {
            MapToShow = SearchMapDesktop;
        }
    }

    return (
        <div className={nonInteractiveMobileSpacing}>
            <MapToShow {...mapProps} />
        </div>
    );
};

export default SearchMapSplitter;
